import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ServiceMessageBrokerFactory,
  ServiceMessageBroker,
} from "shared/provider-webworker";

import { TimezoneLookupService } from "./TimezoneLookupService";
import { PrimaryLookupService } from "../../impl/PrimaryLookupService";
import { ITimezonePromiseLookupService } from "../ITimezonePromiseLookupService";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { PromiseLookupService } from "../../impl/PromiseLookupService";

import { CubiqWorker } from "../../../worker/CubiqWorker";

import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class TimezonePrimaryLookupService
  extends PrimaryLookupService<string, CubiqTS.TimeZoneImpl>
  implements ITimezonePromiseLookupService
{
  constructor(
    protected base: TimezoneLookupService,
    protected factory: ServiceMessageBrokerFactory,
    protected cubiqWorker: CubiqWorker,
  ) {
    super(base, factory, CubiqTS.TimeZoneImpl, cubiqWorker, "TimeZoneImpl");

    cubiqWorker.isAuth(`${this.constructor.name}`).then(
      () => {
        let timezoneObservable = cubiqWorker.primeStaticData<CubiqTS.TimeZoneImpl>(
          CubiqTS.TimeZoneImpl.name,
        );

        timezoneObservable.subscribe(
          (timezone: CubiqTS.TimeZoneImpl[]) => {
            this.base.prime(timezone);
          },
          (error: Error) => {
            logger.out.error("Timezone prime failed");
            this._primed.reject(error);
          },
          () => {
            this._primed.resolve(true);
          },
        );
      },
      (reason) => {
        console.debug("TimezonePrimaryLookupService: Failed to prime: " + reason);

        this._primed.resolve(false);
      },
    );

    this.broker.registerMethod("getTimezone", [PRIMITIVE], this.getTimezone.bind(this), this.VALUE);
    this.broker.registerMethod("getAllTimezones", [], this.getAllTimezones.bind(this), this.VALUE);
  }

  getTimezone(id: string): Promise<CubiqTS.TimeZoneImpl> {
    return new Promise<CubiqTS.TimeZoneImpl>((res, rej) => {
      res(this.base.getTimezone(id));
    });
  }

  getAllTimezones(): Promise<Array<CubiqTS.TimeZoneImpl>> {
    return new Promise<Array<CubiqTS.TimeZoneImpl>>((res, rej) => {
      res(this.base.getAllTimezones());
    });
  }
}
